export default "__VITE_ASSET__CslUS$4E__"